import styled from 'styled-components';
import { flexPosition } from '../../styles/mixins';
import { BLUE_MARINE, GRAY_MORE_DARKER, MAIN_COLOR, WHITE } from '../../styles/variables';

export const FullLoader = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  ${flexPosition({ align: 'center', justify: 'center' })};

  i {
    width: 6em;
    height: 6em;
    animation: spin 1.1s infinite linear;
    border: 6px solid ${MAIN_COLOR};
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-radius: 50%;
  }
`;

export const NormalLoader = styled.div`
  border-radius: 3px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.24);
  color: ${WHITE};
  display: inline-block;
  line-height: 20px;
  margin-top: 8px;
  padding: 16px;
  transition: opacity 200ms, -webkit-transform 300ms cubic-bezier(0.165, 0.84, 0.44, 1);
  white-space: nowrap;
  z-index: 999;
  transform: translateY(40px);
  background: ${GRAY_MORE_DARKER};
  position: fixed;
  bottom: 60px;

  span:first-child {
    border: 2px solid ${BLUE_MARINE};
    border-radius: 50%;
    animation: spin 1.1s infinite linear;
    border-color: ${WHITE};
    border-top-color: transparent;
    display: inline-block;
    height: 16px;
    margin-right: 12px;
    vertical-align: middle;
    width: 16px;
  }

  div {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Loader/style.js